module.exports = __webpack_public_path__ + "img/financial-security.f55ef2e3.svg";